import { AppliedScope } from "../../models/current-applied-scopes";

export class SystemUserGroupMemberRecord {
  email: string;
  jobProfile: string | null;
  fullName: string | null;
  employeeId: string | null;
  memberOfOtherGroups: string[];
  appliedScopes: string[];
  systemResources: {};

  constructor(
    email: string,
    jobProfile: string | null,
    fullName: string | null,
    employeeId: string | null,
    memberOfOtherGroups: string[],
    appliedScopes: AppliedScope[],
    systemResources: {}
  ) {
    this.email = email;
    this.jobProfile = jobProfile;
    this.fullName = fullName;
    this.employeeId = employeeId;
    this.memberOfOtherGroups = memberOfOtherGroups;
    this.appliedScopes = appliedScopes.map((appliedScope) => appliedScope.displayFormat());
    this.systemResources = systemResources;
  }

  title() {
    return this.fullName ?? this.email;
  }

  isAssociatedToScope(scope): boolean {
    return this.appliedScopes.some((appliedScope) => appliedScope === scope);
  }
}
